module.exports = __webpack_public_path__ + "img/menu.6d5b1431.svg";